module.exports = {"510727100":"龙安镇","510727101":"古城镇","510727102":"南坝镇","510727103":"响岩镇","510727104":"平通镇","510727105":"豆叩镇","510727106":"大印镇","510727107":"大桥镇","510727108":"水晶镇","510727200":"高村乡","510727201":"水田羌族乡","510727202":"坝子乡","510727203":"水观乡","510727204":"平南羌族乡","510727205":"徐塘羌族乡","510727206":"锁江羌族乡","510727207":"土城藏族乡","510727208":"旧堡羌族乡","510727209":"阔达藏族乡","510727210":"黄羊关藏族乡","510727211":"虎牙藏族乡","510727212":"泗耳藏族乡","510727213":"白马藏族乡","510727214":"木座藏族乡","510727215":"木皮藏族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510727.json
// module id = 2308
// module chunks = 0